<template lang="pug">
  dv-server-form(
    v-model="form"
    :method="method"
    :success-callback="successCallback"
    :error-callback="errorCallback"
    :schema="schema"
    v-slot="{ fields, loading }"
  )
    .d-flex.flex-column.gap-16
      dv-form-field(
        v-for="field in fields"
        :key="field.name"
        :field="field"
      )
      validation-provider(
        v-if="captchaRequired"
        name="captcha"
        rules="required"
        v-slot="{ errors }"
      )
        yandex-captcha-field(
          ref="captcha"
          v-model="captchaToken"
          :error-messages="errors"
          required
        )
      dv-btn(
        large
        block
        :loading="loading"
        :disabled="captchaRequired && !captchaToken"
        type="submit"
      ) Войти
      dv-btn.fit-content-width(
        text
        :to="{ name: 'forgot-password' }"
      )
        v-icon.mr-2(:size="20") $ui-question-circle
        p Забыли пароль?
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import DvFormField from '@/packages/ui/components/forms/DvFormField.vue';
import DvServerForm from '@/packages/ui/components/forms/DvServerForm.vue';
import DvPasswordField from '@/packages/ui/components/inputs/DvPasswordField.vue';
import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';
import YandexCaptchaField from '@/components/ui-design/fields/YandexCaptchaField.vue';

const CAPTCHA_FAILURE_THRESHOLD = 3;

export default {
  components: {
    DvServerForm,
    DvFormField,
    DvBtn,
    YandexCaptchaField,
  },
  props: {},
  data() {
    return {
      form: {},
      captchaToken: '',
      failedLoginAttempts: 0,
    };
  },
  computed: {
    captchaRequired() {
      return this.failedLoginAttempts >= CAPTCHA_FAILURE_THRESHOLD;
    },
    schema() {
      return [
        {
          value: 'username',
          name: 'username',
          label: 'Логин',
          rules: 'required|username',
          component: DvTextField,
          props: {
            height: 44,
            placeholder: 'Введите логин',
            autocomplete: 'username',
          },
        },
        {
          value: 'password',
          name: 'password',
          label: 'Пароль',
          rules: 'required|password',
          component: DvPasswordField,
          props: {
            height: 44,
            placeholder: 'Введите пароль',
            autocomplete: 'current-password',
          },
        },
      ];
    },
  },
  methods: {
    successCallback(data) {
      this.failedLoginAttempts = 0;
      this.$emit('auth', data);
      this.$toast.success('Вы успешно авторизовались');
    },
    errorCallback() {
      const shouldResetCaptcha = this.captchaRequired;
      this.failedLoginAttempts += 1;

      if (shouldResetCaptcha) {
        this.$nextTick(() => this.$refs.captcha?.reset());
      }
    },
    async method() {
      const payload = {
        ...this.form,
      };

      return this.$rApi.auth.authUserWithCredentials({ data: payload });
    },
  },
};
</script>

<style lang="scss" scoped></style>
